import type { InvoicesFilter } from "../../__generated__/graphql";
import {
  InvoicePaymentStatusEnum,
  InvoiceSortByEnum,
  InvoiceStatusEnum,
  SortEnum,
} from "../../__generated__/graphql";
import type { InvoiceListStatus } from "./types";

export const INVOICE_PAGE_SIZE = 10;

export const INVOICE_TABS: { label: string; value: InvoiceListStatus; path: string }[] = [
  { label: "Unpaid", value: "UNPAID", path: "/profile/invoices/unpaid" },
  { label: "Paid", value: "PAID", path: "/profile/invoices/paid" },
];

const PAYMENT_STATUS_BY_TAB: Record<InvoiceListStatus, InvoicePaymentStatusEnum[]> = {
  UNPAID: [
    InvoicePaymentStatusEnum.Unpaid,
    InvoicePaymentStatusEnum.Underpaid,
    InvoicePaymentStatusEnum.StripeProcessing,
  ],
  PAID: [InvoicePaymentStatusEnum.Paid],
};

export function getInvoiceFilters(status: InvoiceListStatus): Omit<InvoicesFilter, "clientId"> {
  return {
    status: [InvoiceStatusEnum.Confirmed],
    paymentStatus: PAYMENT_STATUS_BY_TAB[status],
    sortBy: [InvoiceSortByEnum.IssueDate],
    sort: [SortEnum.Desc],
    limit: INVOICE_PAGE_SIZE,
    offset: 0,
  };
}
